import { User } from "oidc-client";
import { getUserManager } from "@axa-fr/react-oidc-context";

declare global {
    interface JQueryStatic {
        signalR: any;
        connection: any;
        hubConnection: any;
    }
}

class ChatService {
    public connected: boolean = false;
    public num: number = 0;

    constructor(notifyNewMessageCallback: any, userConnetionStatusCallback: any, disconnectedCallback: any) {
        $.connection.chatHubV2Impl.client.notifyNewMessageCallback = notifyNewMessageCallback;
        $.connection.chatHubV2Impl.client.userConnetionStatusCallback = userConnetionStatusCallback;

        this.connected = false;

        $.connection.hub.disconnected(() => {
            this.connected = false;
            let res = this.onDisconnected(disconnectedCallback);
        });
    }

    onDisconnected(func: any) {
        this.num++;
        setTimeout(async () => {
            if (this.num < 5) {
                let res = await this.startConnection();
                return func(res);
            }

            return func(false);

        }, 1500);
    }

    getConnectedStatus() {
        return this.connected;
    }

    public async startConnection() {
        await this.setAccessToken();

        $.connection.hub.url = window.config.signalRurl;
        $.connection.hub.logging = false;

        try {
            let start = await $.connection.hub.start({ xdomain: true });
            this.connected = true;
            return true;
        } catch (error) {
            console.log("ERROR->", error);
            return false;
        }
    }

    public async setAccessToken() {
        const um = (await getUserManager().getUser()) as User;

        let bearerToken = "";
        if (um) bearerToken = um.access_token;

        $.ajaxPrefilter(function (request) {
            request.headers = request.headers || {};
            request.headers = {
                Authorization: `Bearer ${bearerToken}`,
            };
        });
    }
}

export default ChatService;
